/**
 * @fileoverview gRPC-Web generated client stub for qowner.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/email_owners.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

var projects_erp_service_api_v1_model_email_owner_pb = require('./email_owner_pb.js')
const proto = {};
proto.qowner = {};
proto.qowner.erp = {};
proto.qowner.erp.api = {};
proto.qowner.erp.api.v1 = {};
proto.qowner.erp.api.v1.services = require('./email_owners_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.EmailOwnersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.EmailOwnersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ListEmailOwnersRequest,
 *   !proto.qowner.erp.api.v1.services.ListEmailOwnersResponse>}
 */
const methodDescriptor_EmailOwners_ListEmailOwners = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.EmailOwners/ListEmailOwners',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ListEmailOwnersRequest,
  proto.qowner.erp.api.v1.services.ListEmailOwnersResponse,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ListEmailOwnersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.qowner.erp.api.v1.services.ListEmailOwnersResponse.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ListEmailOwnersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.services.ListEmailOwnersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.services.ListEmailOwnersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.EmailOwnersClient.prototype.listEmailOwners =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.EmailOwners/ListEmailOwners',
      request,
      metadata || {},
      methodDescriptor_EmailOwners_ListEmailOwners,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ListEmailOwnersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.services.ListEmailOwnersResponse>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.EmailOwnersPromiseClient.prototype.listEmailOwners =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.EmailOwners/ListEmailOwners',
      request,
      metadata || {},
      methodDescriptor_EmailOwners_ListEmailOwners);
};


module.exports = proto.qowner.erp.api.v1.services;

